<template>
  <div
    :class="[
      $style.item,
      (disabled || data.IsSoldOut) && $style.disabled,
      data.IsSoldOut && $style.isSoldOut
    ]"
    @click="click"
  >
    <AspectRatioPlaceholder :width="1" :height="1">
      <img :class="$style.itemImg" :src="data.Image" />
      <span :class="$style.soldOut">已抢空</span>
    </AspectRatioPlaceholder>

    <div :class="$style.itemDetail">
      <div :class="$style.itemName" :title="data.Name">
        <span>{{ data.Name }}</span>
      </div>
      <div :class="$style.price">
        <span :class="$style.salePrice">
          <span :class="$style.priceSymbol">￥</span>{{ data.SalePrice }}
        </span>
      </div>

      <button :class="$style.btn" @click.stop="action">
        {{ config.BeforeButtonDesc }}
      </button>
    </div>
  </div>
</template>

<script>
import AspectRatioPlaceholder from "base-components/AspectRatioPlaceholder";

// Image: "https://i1.lifevccdn.com//upload/goods//upload/goods/D1704201923144854.jpg"
// ItemInfoId: 21599
// Name: "酵素洗衣液(超强洁净)"
// SalePrice: 49
export default {
  name: "GoodItem",
  props: {
    config: {},
    data: {},
    disabled: {
      type: Boolean
    }
  },
  components: {
    AspectRatioPlaceholder
  },
  // computed: {
  //   disabled() {
  //     return this.data.IsSoldOut || !this.data.IsCanReceive;
  //   }
  // },
  data() {
    return {};
  },
  methods: {
    click() {
      this.$emit("click", this.data);
    },
    action() {
      if (this.disabled || this.data.IsSoldOut) {
        return;
      }
      this.$emit("action", this.data);
    }
  }
};
</script>

<style lang="scss" module>
$page-width: 375;
@import "~style/tool";

.item {
  line-height: 1;
  background: #fff;
  border-radius: 2px;
  overflow: hidden;
  padding-bottom: 8px;

  // :global {
  //   .AspectRatioPlaceholder {
  //     background: transparent;
  //   }
  // }
}

.itemImg {
  width: 100%;
  height: 100%;
}
.itemDetail {
  line-height: 1;
  padding-top: rem(10);
  padding-bottom: rem(15);
}
.itemName {
  font-size: rem(12);
  height: rem(36);
  overflow: hidden;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: rem(18);
}

.price {
  margin-top: rem(5);
  padding-bottom: rem(9);
  font-weight: bold;
  color: rgba(201, 80, 82, 1);
}
.salePrice {
  font-size: rem(14);
}
.priceSymbol {
  font-size: rem(14);
}

.btn {
  padding: 0;
  padding-top: rem(1);
  margin-top: rem(2);
  width: 100%;
  height: rem(20);
  line-height: rem(20);
  background: rgba(201, 80, 82, 1);
  border-radius: rem(1);
  font-size: rem(12);
  color: rgba(255, 255, 255, 1);
}

.disabled {
  .btn {
    background: #bebebe;
  }
}

.soldOut {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: rem(57);
  height: rem(57);
  line-height: rem(57);
  text-align: center;
  color: #fff;
  background: rgba(51, 51, 51, 1);
  border-radius: 100%;
  opacity: 0.6;
  display: none;
}

.isSoldOut .soldOut {
  display: block;
}
</style>
